<template>
    <div :class="{'form-wrapper': true, 'form-border': true}">
        <div v-if="title" class="form-header" @click="collapsed = !collapsed">
            <icon :icon="['fal', collapsed ? 'caret-right' : 'caret-down']"></icon>&nbsp;{{ title }}
        </div>
        <template v-if="!collapsed">
            <slot/>
        </template>
    </div>
</template>

<script>
export default {
    name: "FramedContent",
    props: {
        title: String,
        defaultCollapsed: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            collapsed: false
        }
    },
    mounted() {
        if (this.$props.defaultCollapsed) this.collapsed = true;
    }
}
</script>

<style lang="scss" scoped>
.form-wrapper {
    margin-top: 15px;
    margin-bottom: 10px;
    position: relative;
}

.form-border {
    border: 1px solid #505C69;
    padding: 15px 10px 10px 10px;
    margin-bottom: 20px;
}

.form-header {
    position: absolute;
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
    top: -10px;
    left: 20px;
    height: 20px;
    padding: 0px 10px 0px 10px;
    background-color: #505C69;
    border-radius: 4px;
    cursor: pointer
}

</style>